import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle, Route } from '@angular/router';

@Injectable()

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  private routeStore: Map<string, DetachedRouteHandle> = new Map<string, DetachedRouteHandle>();

  override shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // console.log('CustomRouteReuseStrategy shouldDetach', !!route.routeConfig && !!route.data['reuse']);
    return !!route.routeConfig && !!route.data['reuse'];
  }

  override store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    // console.log('CustomRouteReuseStrategy store', route, handle);
    this.routeStore.set(route.routeConfig?.path as string, handle);
  }

  override shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // console.log('CustomRouteReuseStrategy shouldAttach', route);
    return this.routeStore.has(route.routeConfig?.path as string);
  }

  override retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    // console.log('CustomRouteReuseStrategy retrieve', route);
    return this.routeStore.get(route.routeConfig?.path as string) as DetachedRouteHandle;
  }

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  override shouldDestroyInjector(route: Route): boolean {
    const key = route.path;
    return !(key && this.routeStore.has(key));
  }
}
